// TODO: check the use of enhanceColumnDefs
// import { enhanceColumnDefs } from '@gu-datagrid/utils/format'

// // Get pageVars from window object.
// const { pageVars } = window
// const { configIcApplications, enumerationTypes } = pageVars
// const { columnDefs } = configIcApplications

// try {
//   enhanceColumnDefs(columnDefs, enumerationTypes)
// } catch (err) {
//   console.error(err)
// }

const defaultColDef = {
  menuTabs: [
    'filterMenuTab',
    'generalMenuTab',
    'columnsMenuTab',
  ],
  resizable: true,
  sortable: true,
  filter: true,
}

export function buildGridConfig (siteConfig) {
  return {
    allowContextMenuWithControlKey: true,
    allowDragFromColumnsToolPanel: true,
    columnDefs: siteConfig.columnDefs,
    defaultColDef,
    enableCellTextSelection: true,
    ensureDomOrder: true,
    overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Loading...</span>',
    overlayNoRowsTemplate: '<span class="ag-overlay-no-rows-center">No data to display</span>',
    pagination: true,
    paginationAutoPageSize: true,
    rowClassRules: {
      'table-danger': function (params) {
        if (params.data) {
          return params.data.open_defects > 0
        }
      },
    },
    statusBar: {},
    suppressColumnVirtualisation: true,
  }
}
